export default {
      id: "return-on-investment-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#return-on-investment",
      toString: function () {
        return this.url;
      }
    }